'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$59() {
  this.blA = null;
  this.blB = false;
}
export { $c_Lpresto_PrestoRouter$$anon$59 as $c_Lpresto_PrestoRouter$$anon$59 };
$p = $c_Lpresto_PrestoRouter$$anon$59.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$59;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$59() {
}
export { $h_Lpresto_PrestoRouter$$anon$59 as $h_Lpresto_PrestoRouter$$anon$59 };
$h_Lpresto_PrestoRouter$$anon$59.prototype = $p;
$p.P = (function() {
  if ((!this.blB)) {
    this.blA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.blB = true;
  }
  return this.blA;
});
var $d_Lpresto_PrestoRouter$$anon$59 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$59, "presto.PrestoRouter$$anon$59", ({
  Oz: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$59 as $d_Lpresto_PrestoRouter$$anon$59 };
//# sourceMappingURL=presto.-Presto-Router$$anon$59.js.map
